import React from "react";

import "./FormPanel.scss";

/** Component that renders a form wrapper (backgrount + border)
 */
const FormPanel = props => (
  <section className="FormPanel">{props.children}</section>
);

export default FormPanel;
